export default __webpack_public_path__ + "static/media/close-overlay.a776e5df.svg";